import { useState, useRef } from "react";
import { Habit, Context } from "../types";

export const useTouchHandlers = (
  onEditHabit: (habit: Habit) => void,
  onEditContext: (context: Context) => void
) => {
  const [pressStartTime, setPressStartTime] = useState<number | null>(null);
  const [pressScale, setPressScale] = useState(1);
  const [pressedItemId, setPressedItemId] = useState<number | null>(null);
  const [initialTouchY, setInitialTouchY] = useState<number | null>(null);
  const [hasScrolled, setHasScrolled] = useState(false);
  
  const pressTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const scaleTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handlePressStart = (item: Habit | Context, event: React.MouseEvent | React.TouchEvent) => {
    setPressStartTime(Date.now());
    setPressedItemId(item.id);
    setPressScale(1);
    setHasScrolled(false);

    const y = 'touches' in event ? event.touches[0].clientY : event.clientY;
    setInitialTouchY(y);

    const scaleTimer = setTimeout(() => {
      if (!hasScrolled) {
        setPressScale(0.90);
      }
    }, 300);
    scaleTimeoutRef.current = scaleTimer;

    const settingsTimer = setTimeout(() => {
      if (!hasScrolled) {
        if ('score' in item) {
          onEditHabit(item as Habit);
        } else {
          onEditContext(item as Context);
        }
      }
    }, 800);

    pressTimeoutRef.current = settingsTimer;
  };

  const handlePressMove = (event: React.MouseEvent | React.TouchEvent) => {
    if (initialTouchY === null) return;

    const currentY = 'touches' in event ? event.touches[0].clientY : event.clientY;
    const deltaY = Math.abs(currentY - initialTouchY);

    if (deltaY > 10) {
      setHasScrolled(true);
      if (pressTimeoutRef.current) {
        clearTimeout(pressTimeoutRef.current);
        pressTimeoutRef.current = null;
      }
      if (scaleTimeoutRef.current) {
        clearTimeout(scaleTimeoutRef.current);
        scaleTimeoutRef.current = null;
      }
      setPressScale(1);
    }
  };

  const handlePressEnd = () => {
    setPressStartTime(null);
    setPressedItemId(null);
    setPressScale(1);
    setInitialTouchY(null);
    setHasScrolled(false);
    if (pressTimeoutRef.current) {
      clearTimeout(pressTimeoutRef.current);
      pressTimeoutRef.current = null;
    }
    if (scaleTimeoutRef.current) {
      clearTimeout(scaleTimeoutRef.current);
      scaleTimeoutRef.current = null;
    }
  };

  const handlePressCancel = () => {
    setPressStartTime(null);
    setPressedItemId(null);
    setPressScale(1);
    setInitialTouchY(null);
    setHasScrolled(false);
    if (pressTimeoutRef.current) {
      clearTimeout(pressTimeoutRef.current);
      pressTimeoutRef.current = null;
    }
    if (scaleTimeoutRef.current) {
      clearTimeout(scaleTimeoutRef.current);
      scaleTimeoutRef.current = null;
    }
  };

  return {
    pressStartTime,
    pressScale,
    pressedItemId,
    handlePressStart,
    handlePressMove,
    handlePressEnd,
    handlePressCancel,
  };
};